var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 24,
    viewBox: "0 0 23 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "edit-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.4658 19.2988H19.8433",
    stroke: "#888B9B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M15.654 3.93967C16.0244 3.56936 16.5266 3.36133 17.0503 3.36133C17.3096 3.36133 17.5664 3.4124 17.8059 3.51163C18.0455 3.61087 18.2632 3.75631 18.4465 3.93967C18.6299 4.12303 18.7753 4.3407 18.8746 4.58027C18.9738 4.81984 19.0249 5.0766 19.0249 5.33591C19.0249 5.59521 18.9738 5.85198 18.8746 6.09155C18.7753 6.33112 18.6299 6.54879 18.4465 6.73215L6.8112 18.3675L3.08789 19.2983L4.01872 15.575L15.654 3.93967Z",
    stroke: "#888B9B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPen);
export default __webpack_public_path__ + "static/media/pen.504e45f1d0357f761dcd5d6fcd35f1bb.svg";
export { ForwardRef as ReactComponent };